import SeasonDataService from '../services/season-data.service';
import CommunityDataService from '../services/community-data.service';
import MatchDayDataService from '../services/match-day-data.service';

export const sys = {
    namespaced: true,
    state: {
        isMaintenance: false,
        maintenanceUser: null,
        matchDay: null,
        selectedMatchDay: null,
        seasonYear: null,
        subscription: null,
        lastCalcMatchDay: 1
    },
    actions: {
        checkMode({commit}) {
            return SeasonDataService.getMode()
                .then(mode => {
                        console.log("Maintenance Mode: " + mode.data.isMaintenanceMode);
                        if (mode.data.isMaintenanceMode) {
                            commit('setModeMaintenance');
                            // console.log("Maintenance Mode active!");
                        } else {
                            commit('setModeNoMaintenance');
                            // console.log("Maintenance Mode inactive!");
                        }
                    },
                    error => {
                        commit('setModeNoMaintenance');
                        console.error(error);
                    });
        },
        switchMaintenanceUser({commit}, newValue) {
            commit('setMaintenanceUser', newValue);
            /*
                      if(newValue !== null){
                          console.log("Now acting as user: " + newValue.surname);
                      } else {
                          console.log("Removed maintenance user");
                      }
            */
        },
        getCurrentMatchDay({commit}) {
            return MatchDayDataService.getCurrentMatchDay()
                .then(day => {
                        let currentDay = day.data.groupOrderID;
                        commit('setMatchDay', currentDay);
                        if(this.state.selectedMatchDay == null){
                            commit('setSelectedMatchDay', currentDay);
                        }
                        console.log("State set - CurrentMatchDay: " + currentDay);
                    },
                    error => {
                        console.error('Error getting current match day' + error.message);
                    })
        },
        getCurrentSeasonYear({commit}) {
            return SeasonDataService.getCurrentSeasonYear()
                .then(data => {
                        // console.log("CurrentSeasonYear " + JSON.stringify(data.data));
                        commit('setSeasonYear', data.data.year);
                    },
                    error => {
                        console.error(error);
                    })
        },
        getSubscription({commit}) {
            return CommunityDataService.getCurrentSubscription()
                .then(data => {
                        // console.log("Subscription " + JSON.stringify(data.data));
                        commit('setSubscription', data.data);
                    },
                    error => {
                        console.error(error);
                    })
        },
        getLastCalculatedMatchDay({commit}, season) {
            return MatchDayDataService.getLastCalcMatchDay(season)
                .then(day => {
                    console.log("LastCalcMatchDay response: " + JSON.stringify(day.response));
                        commit('setLastCalcMatchDay', day.data.dayNumber);
                        // console.log("LastCalcMatchDay: " + day.data.dayNumber);
                    },
                error => {
                    if (error.response.status === 500){
                        commit('setLastCalcMatchDay', 1);
                    } else {
                        console.log("Error last calculated day: " + error.message);
                    }
                })
        }
    },
    getters: {
        maintenanceUser: (state) => {
            return state.maintenanceUser;
        }
    },
    mutations: {
        setModeMaintenance(state) {
            state.isMaintenance = true;
        },
        setMaintenanceUser(state, id) {
            state.maintenanceUser = id;
        },
        setModeNoMaintenance(state) {
            state.isMaintenance = false;
        },
        setMatchDay(state, day) {
            state.matchDay = day;
        },
        setSelectedMatchDay(state, day) {
            state.selectedMatchDay = day;
        },
        setSeasonYear(state, year) {
            state.seasonYear = year;
        },
        setSubscription(state, subscription) {
            state.subscription = subscription;
        },
        setLastCalcMatchDay(state, day) {
            state.lastCalcMatchDay = day;
        }
    }
};
